import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../../../_metronic/helpers'
import {memo} from 'react'
import {useRoleUser} from '../../../../../hooks/useRoleUser'
import {ActionIcon, PopoverText} from 'src/components'

interface IData {
  id: number
  module?: string
  sectors: any[]
  sales_orgs: any[]
  time_type: string
  time: string
  is_active: number
  created_at?: string
  updated_at?: string
}

export interface RowDataProps {
  rowNumber: number
  data: IData
  isLoadingEditButton: boolean
  onEdit: (data: IData) => void
  onDelete: (data: IData) => void
}

export const RowData = memo((props: RowDataProps) => {
  const {isLoadingEditButton, rowNumber, data, onEdit, onDelete} = props
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  return (
    <tr>
      <td>{rowNumber}</td>
      <td>
        <PopoverText
          content={
            data?.sectors.length > 0
              ? data?.sectors
                  .map((item, index) => {
                    return item.name
                  })
                  .join(', ')
              : '-'
          }
          index={rowNumber}
          trigger='click'
          className='desc-slicee'
        />
      </td>
      <td>
        <PopoverText
          content={
            data?.sales_orgs.length > 0
              ? data?.sales_orgs
                  .map((item, index) => {
                    return item.name
                  })
                  .join(', ')
              : '-'
          }
          index={rowNumber}
          trigger='click'
          className='desc-slicee'
        />
      </td>
      <td>{ parseInt(data.time) } { t('due-date-' + data.time_type) }</td>
      <td>
        <span className='d-block '>
          {data.is_active == 0 ? (
            <span className='badge badge-light-danger'>{t('Non-Active')}</span>
          ) : (
            <span className='badge badge-light-success'>{t('Active')}</span>
          )}
        </span>
      </td>
      <td>
        <ActionIcon
          className='me-2'
          title={t('Edit')}
          iconPath='/media/icons/duotune/pencil-fill.svg'
          isLoading={isLoadingEditButton}
          disabled={isLoadingEditButton}
          onClick={() => onEdit(data)}
        />
        <button
          className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          title={t('Hapus')}
          onClick={() => onDelete(data)}
        >
          <KTSVG path='/media/icons/duotune/trash-fill.svg' className='svg-icon-3' />
        </button>
      </td>
    </tr>
  )
})
